import Vue from 'vue';

export default {
  paginate(state, pagination) {
    state.pagination = pagination;
  },

  addPlayerIds(state, { order, playerIds }) {
    if (!state.phasePlayerIds[order]) {
      Vue.set(state.phasePlayerIds, order, new Set(playerIds));
    } else {
      const newSet = new Set(state.phasePlayerIds[order]);
      playerIds.forEach(id => newSet.add(id));
      Vue.set(state.phasePlayerIds, order, newSet);
    }
  },

  removePlayerIds(state, { order, playerIds }) {
    if (!state.phasePlayerIds[order]) return;

    const newSet = new Set(state.phasePlayerIds[order]);
    playerIds.forEach(id => newSet.delete(id));
    Vue.set(state.phasePlayerIds, order, newSet);
  },

  setPhasePlayerIds(state, playerIds) {
    state.phasePlayerIds = playerIds;
  },
};



// WEBPACK FOOTER //
// ./src/store/trainings/mutations.js